import React from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import LoginPage from "../Landing/LoginPage";
import MainDashboard from "../MainDashboard";
import VideoComponent from "../Landing/VideoComponent";

/*HOC ROUTES*/
import AdminRoute from "./AdminRoute";
import PharmacistRoute from "./PharmacistRoute";
//import TechnicianRoute from "./TechnicianRoute";

/*ADMIN ROUTES*/
import Dashboard2 from "../admin/Dashboard2";
import EditUser from "../admin/EditUser";
import CreateUser from "../admin/CreateUser";
import ApplicationSettings from "../admin/ApplicationSettings";
import PharmacistDashboard from "../pharmacist/PharmacistDashboard";
import PharmaStoreComponent from "../Landing/PharmaStoreComponent"

/*PHARMACIST ROUTES*/
import DraftComponent from "../pharmacist/DraftComponent";
import PrescriptionComponent from "../pharmacist/Prescription/PrescriptionComponent";
import PendingView from "../pharmacist/PendingReview/PendingView";
import Approved from "../pharmacist/Approved/Approved";
import UserManagement from '../admin/UsersList'

import DashBoardComponent from "../DashBoardComponent"
import ForgotPassword from "../Landing/ForgotPassword";
import ResetPassword from "../Landing/ResetPassword";

/*TECHNICIAN ROUTES*/

const Routes = ({ isAuthenticated }) => (
    <div>
        <Switch>
            <Route exact path="/" component={LoginPage} />
            {/*<Route exact path="/patient-portal" component={PatientPortal}/>*/}
            <Route exact path="/store" component={PharmaStoreComponent} />
            <Route exact path="/patient-portal" component={VideoComponent} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/auth/user/reset-password/:token" component={ResetPassword} />
            {isAuthenticated ? <Route exact path="/dashboard" component={MainDashboard} /> : <Redirect to="/" />}

            <AdminRoute exact path="/dashboard2" component={Dashboard2} />
            <AdminRoute exact path="/dashboard2/user-management" component={UserManagement} />
            <AdminRoute exact path="/dashboard2/create-user" component={UserManagement} />
            <AdminRoute exact path="/dashboard2/application-settings" component={ApplicationSettings} />
            <AdminRoute exact path="/edit-user/:id" component={EditUser} />

            <AdminRoute exact path="/dashboard2" component={Dashboard2} />
            <AdminRoute exact path="/dashboard2/user-management" component={UserManagement} />
            <AdminRoute exact path="/edit-user/:id" component={EditUser} />
            {isAuthenticated ? <Route exact path="/pharmacist-dashboard" component={DashBoardComponent} /> :
                <Redirect to="/" />}
            {isAuthenticated ? <Route exact path="/draft" component={DraftComponent} /> : <Redirect to="/" />}
            {isAuthenticated ? <Route exact path="/prescription-component/:id/:prescriptionNumber" component={PrescriptionComponent} /> :
                <Redirect to="/" />}
            {isAuthenticated ? <Route exact path="/pending-view/:id/:prescriptionNumber/:type" component={PendingView} /> : <Redirect to="/" />}{isAuthenticated ? <Route exact path="/approved/:id/:prescriptionNumber" component={Approved} /> :
                <Redirect to="/" />}
            {isAuthenticated ? <Route exact path="/approved/:id/:prescriptionNumber" component={Approved} /> :
                <Redirect to="/" />}
        </Switch>
    </div>
);

Routes.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated
});

export default withRouter(connect(mapStateToProps, {})(Routes));
